<template>
    <div>

        <v-dialog v-model="formDialog" persistent max-width="600px">
            <v-card>
                <v-card-title>Add Payment
                    <v-spacer/><v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form">
                        <v-row>
                            <v-col cols="12">
                                <label class="text-uppercase grey--text font-weight-bold">Customer*</label>
                                <v-autocomplete outlined dense :items="customers" :search-input.sync="searchCustomer" clearable
                                                v-model="selectedCustomer" item-text="name" item-value="id" :loading="$apollo.queries.customers.loading"/>
                            </v-col>
                            <v-col cols="6">
                                <label class="text-uppercase grey--text font-weight-bold">Amount*</label>
                                <v-text-field outlined dense v-model="form.amount" @keydown="allowOnlyPositiveValues($event)"
                                              type="number" :rules="[ v => v > 0 || 'Please Enter Amount']"/>
                            </v-col>
                            <v-col cols="12">
                                <label class="text-uppercase grey--text font-weight-bold">Payment Mode</label><br>
                                <v-btn-toggle v-model="form.paymentTypeId" tile color="deep-purple accent-3" group>
                                    <v-btn small v-for="(type, index) in paymentTypes" :key="index" :value="type.id">{{type.name}}</v-btn>
                                </v-btn-toggle>
                            </v-col>
                            <v-col cols="12">
                                <label class="text-uppercase grey--text font-weight-bold">Note</label>
                                <v-textarea outlined auto-grow :rows="4" placeholder="Enter Note..." v-model="form.note" class="mt-3"/>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="mt-5">
                    <v-spacer></v-spacer>
                    <v-btn class="text-capitalize white elevation-0" text @click="closeDialog">Close</v-btn>
                    <v-btn class="primary px-3 text-capitalize" :loading="formLoading" dark @click="handleSubmit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <Snackbar :toaster="toaster"></Snackbar>
    </div>
</template>

<script>
import Constants from "../../Constants/Constants";
import {GET_PAYMENT_TYPES} from "../../graphql/queries/Settings";
import {SAVE_OPENING_BALANCE} from "../../graphql/mutations/Customers";
import Snackbar from "../../components/Common/Snackbar";
import SearchCustomer from '../../mixins/searchCustomer';
let user = JSON.parse(localStorage.user)
let form = { type:'CREDIT', note:'', amount:0, paymentTypeId:Constants.PaymentType.Cash, collectedBy:user.id, createdBy:user.id}
export default {
    name: "AddPayment",
    components: {Snackbar},
    props: ['formDialog'],
    mixins: [SearchCustomer],
    apollo: {
        paymentTypes: {
            query: GET_PAYMENT_TYPES,
            fetchPolicy: 'network-only',
        },
    },
    data(){
        return{
            Constants: Constants,
            user: user,
            form: {...form},
            formLoading: false,
            paymentTypes: [],
            toaster: { enable: false }
        }
    },
    methods:{
        handleSubmit() {
            if (this.$refs.form.validate())
                console.log('passed') //this.savePayment()
        },
        async savePayment() {
            this.formLoading = true
            let response = await this.$apollo.mutate({
                mutation: SAVE_OPENING_BALANCE,
                variables: {
                    creditDebit: {
                        ...this.form
                    },
                    updateColumns: []
                }
            })
            if(response.data){
                this.formLoading = false
                this.toaster = { enable:true, color:'green', message: `Payment added Successfully`}
                this.closeDialog()
            }
        },
        closeDialog(){
            this.$refs.form.resetValidation()
            this.form = {...form}
            this.$emit('update:formDialog', false)
        },
        allowOnlyPositiveValues(e){
            if(!((e.keyCode > 95 && e.keyCode < 106)
                || (e.keyCode > 47 && e.keyCode < 58)
                || [8, 9].includes(e.keyCode))) {
                e.preventDefault()
            }
        },
    }
}
</script>

<style scoped>

</style>